'use strict';

module.exports = function (ngModule) {
    ngModule.directive('ngRightClick', require('./rightclick'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/directives/rightclick/index.js
 **/